import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

const StarRatingSelector = ({ rating, onRatingChange }) => {
  const [hoveredRating, setHoveredRating] = useState(0)

  const renderStars = () => {
    const stars = []

    for (let i = 1; i <= 5; i++) {
      const isFilled = i <= (hoveredRating || rating)
      stars.push(
        <FontAwesomeIcon
          key={`star_${i}`}
          className={isFilled ? 'star filled' : 'star'}
          icon={faStar}
          onClick={() => onRatingChange(i)}
          onMouseEnter={() => setHoveredRating(i)}
          onMouseLeave={() => setHoveredRating(0)}
        />,
      )
    }

    return stars
  }

  return <div className="star-rating">{renderStars()}</div>
}

export default StarRatingSelector
